export const ANSWER_FETCH_SUCCESS = 'knowledge_base/ANSWER_FETCH_SUCCESS';
export const ANSWER_UPDATE_SEARCH_RESULTS = 'knowledge_base/ANSWER_UPDATE_SEARCH_RESULTS';
export const ANSWER_UPDATE_SELECTED_ANSWER = 'knowledge_base/ANSWER_UPDATE_SELECTED_ANSWER';
export const ANSWER_CLEAR_SEARCH_RESULTS = 'knowledge_base/ANSWER_CLEAR_SEARCH_RESULTS';
